// extracted by mini-css-extract-plugin
export default {"galleryHeader":"c-o_fX"};